var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertWarningTriangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 34 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_644_5777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4171 1.37208C15.5782 -0.59334 18.4218 -0.593332 19.5829 1.37209L33.3787 24.7241C34.5602 26.7239 33.1186 29.25 30.7958 29.25H3.20419C0.881423 29.25 -0.560206 26.7239 0.621259 24.7241L14.4171 1.37208Z",
    fill: "#FDA302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8454 8.75513C18.8454 7.67108 18.0508 7 17 7C15.974 7 15.1538 7.69689 15.1538 8.75513V18.6947C15.1538 19.753 15.974 20.4499 17 20.4499C18.0508 20.4499 18.8454 19.778 18.8454 18.6947V8.75513ZM19 23.9859C18.9991 23.4521 18.7881 22.9404 18.4132 22.563C18.0383 22.1857 17.5301 21.9734 17 21.9727C16.4699 21.9734 15.9617 22.1857 15.5868 22.563C15.2119 22.9404 15.0009 23.4521 15 23.9859C15.0007 24.5199 15.2116 25.0318 15.5865 25.4094C15.9614 25.7869 16.4698 25.9993 17 26C17.5302 25.9993 18.0386 25.7869 18.4135 25.4094C18.7884 25.0318 18.9993 24.5199 19 23.9859Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_644_5777"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertWarningTriangle);
export default __webpack_public_path__ + "static/media/alert-warning-triangle.7623e4eab7b1887f4d18ba15fe7aae86.svg";
export { ForwardRef as ReactComponent };